import { BLOG_URL } from 'lib/constants';

// Labels come from the `nav` section of the i18n dictionaries (src/i18n).
const allNavLinks = [
  { href: '#home', key: 'home' },
  { href: '#about', key: 'about' },
  { href: '#experience', key: 'experience' },
  { href: '#projects', key: 'projects' },
  { href: '#articles', key: 'articles' },
  { href: '#contact', key: 'contact' },
] as const;

export const navLinks = allNavLinks.filter((link) => link.key !== 'articles' || BLOG_URL);
